import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import searchPosts from '../../api/graphql/queries/searchPosts';

class AutocompleteArrayPosts extends Component {
  state = {
    // The active selection's index
    activeSuggestion: 0,
    // The suggestions that match the user's input
    filteredSuggestions: [],
    // Whether or not the suggestion list is shown
    showSuggestions: false,
    // What the user has entered
    userInput: '',
    subArray: [],
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        userInput: value,
      });
    }
    return null;
  }

  searchPost = async (e) => {
    const { value } = e.target;
    if (value === '') return [];
    const res = await searchPosts(value);
    if (res === null) return [];
    return res;
  };

  onChange = async (e) => {
    const userInput = e.currentTarget.value;
    this.setState({ userInput });
    const suggestionObjects = await this.searchPost(e);
    const suggestions = await suggestionObjects.map(i => i.slugName);
    // const { suggestions } = this.props;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = (await suggestions) && suggestions.filter(suggestion => suggestion && suggestion.toLowerCase().indexOf(userInput && userInput.toLowerCase()) > -1);

    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
    });
  };

  onClick = (e) => {
    const { storeArray, name } = this.props;
    const { subArray } = this.state;
    const addingArrayWithDuplicates = [...subArray, e.currentTarget.innerText.toLowerCase()];
    const addingArray = [...new Set(addingArrayWithDuplicates)];
    this.setState(
      {
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: '',
        subArray: addingArray,
      },
      () => {
        storeArray(name, addingArray);
      },
    );
  };

  render() {
    const {
      onChange,
      onClick,
      state: {
        activeSuggestion, filteredSuggestions, showSuggestions, userInput, subArray,
      },
    } = this;

    const {
      message, title, value, action, isLocked, textColor,
    } = this.props;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions && filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="list-none mt-0 pl-0" style={{ overflowY: 'auto', width: 'calc(300px + 1 rem)' }}>
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'cursor-pointer';
              }

              return (
                <li className={`${className} p-2 uppercase hover:text-black hover:bg-white `} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions">
            <em>{message}</em>
          </div>
        );
      }
    }

    return (
      <Fragment>
        {(action === 'create' || action === 'modify') && (
          <div className="flex flex-col font-americaMonoRegular text-xs uppercase mb-2 ">
            <span className={`text-${textColor}`}>{title}</span>
            <input type="text" onChange={onChange} value={userInput} className={`mt-2 rounded-full border-1 p-2 bg-${isLocked ? 'grey' : 'white'} text-black outline-none`} disabled={isLocked} />
            {suggestionsListComponent}
          </div>
        )}
        {(action === 'display' || action === 'delete') && (
          <div className="flex flex-col font-americaMonoRegular text-xs uppercase mb-2 ">
            <span>{title}</span>
            <input type="text" value={value} className="mt-2 rounded-full border-1 p-2 bg-grey text-black outline-none" disabled />
          </div>
        )}
      </Fragment>
    );
  }
}

AutocompleteArrayPosts.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  value: PropTypes.string,
  message: PropTypes.string.isRequired,
  storeArray: PropTypes.func.isRequired,
  isLocked: PropTypes.bool,
  textColor: PropTypes.string,
};

AutocompleteArrayPosts.defaultProps = {
  value: '',
  isLocked: false,
  suggestions: [],
  textColor: 'white',
};

export default AutocompleteArrayPosts;
